import React, { useState } from 'react';
import { Button } from 'antd';
import { CustomCalendar } from '../Calendar';
import { useCalendar } from '../../../contexts/CalendarContext';
import { formatDateWithDay } from '../../../utils/FormatDate';
import { CustomLeftChevronIcon } from '../../../assets/icons';
export function SelectCalendarMobile({ formik }) {
    const { closeDateModal, isDateModalVisible, activeButton, setActiveButton, } = useCalendar();
    const [hasShadow, setHasShadow] = useState(false);
    const handleDateSelect = (departure, returnDate) => {
        formik.setFieldValue('dateRange', [departure, returnDate]);
    };
    const handleScroll = (event) => {
        const scrollTop = event.currentTarget.scrollTop;
        setHasShadow(scrollTop > 0);
    };
    if (!isDateModalVisible) {
        return null;
    }
    ;
    return (React.createElement("div", { "data-testid": "modal-container", className: `fixed bottom-0 left-0 w-full h-full bg-white z-50 transition-transform duration-300` },
        React.createElement("div", { "data-testid": "header-div", className: `flex p-4 ${hasShadow ? 'shadow-lg' : ''} transition-shadow duration-300` },
            React.createElement(Button, { "data-testid": "close-button", onClick: closeDateModal, type: "text", className: "text-black" },
                React.createElement(CustomLeftChevronIcon, { className: "-ml-6" })),
            React.createElement("div", { className: "flex justify-around w-full border border-gray rounded-lg ml-2" },
                React.createElement("button", { "data-testid": "departure-button", type: "button", className: `w-full border-2 rounded-lg font-normal ${activeButton === 'departure' ? 'border-orange-600' : 'border-transparent'} `, onClick: () => setActiveButton('departure') }, !formik.values.dateRange[0]
                    ? 'Ida'
                    : formatDateWithDay(formik.values.dateRange[0])),
                React.createElement("button", { "data-testid": "return-button", type: "button", className: `w-full border-2 rounded-lg font-normal ${activeButton === 'return' ? 'border-orange-600' : 'border-transparent'}`, onClick: () => setActiveButton('return') }, !formik.values.dateRange[1]
                    ? 'Volta'
                    : formatDateWithDay(formik.values.dateRange[1])))),
        React.createElement("div", { "data-testid": "scroll-div", className: `p-4 overflow-y-auto scrollbar-hide`, onScroll: handleScroll },
            React.createElement(CustomCalendar, { onSelectDate: handleDateSelect }))));
}
//# sourceMappingURL=index.js.map